import React, { useState, useEffect } from "react";
import { Card, CardContent, Grid , Typography } from "@material-ui/core";
import ChooseViewDropdown from "./e_view/_e_dropdowns";
import { useSelector } from "react-redux";
import { adminService } from "../../../services/admin.service";
import { useMediaQuery } from "react-responsive";


export default function Usage() {
  
const isTabletOrMobile = useMediaQuery({ query: "(min-width: 768px)" });
const isTabletOrMobileIpad = useMediaQuery({ query: "(min-width: 1024px)" });  
const isTabletOrMobileIpadMax = useMediaQuery({    query: "(min-width: 1366px)",  });
let width = "";
let TabletOrMobileHeight = "";
let legendLabelFont = 10
let isMobile = true;

  const [pageLevelTips, setpageLevelTips] = useState(false);
  let widgets = useSelector((store) => store?.parametersWidgets?.WidgetLookUp);
  const [tipsLocation, settipsLocation] = useState([]);
  
  let lang = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  let tenantName = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.TENANT_NAME
  );
  useEffect(() => {
    if (widgets) {
      let tips = [];
      widgets.forEach((item) => {
        if (
          item.widgetCode === "PAGE_LEVEL_TIPS" &&
          item.widgetDefaultValue === "true"
        ) {
          setpageLevelTips(true);
          tips.push(item.widgetCode);
        } else if (
          item.widgetCode === "SIDEBAR.USAGE" &&
          item.widgetDefaultValue === "true"
        ) {
          tips.push(item.widgetCode);
        }
      });
      settipsLocation(tips);
    }
  }, [widgets]);
  if (
    isTabletOrMobile === true &&
    isTabletOrMobileIpadMax === true &&
    isTabletOrMobileIpad === true
  ) {
    TabletOrMobileHeight = "246px";
    legendLabelFont = 14;
    isMobile = false;
    width = "100%";
  } else if (
    isTabletOrMobile === false &&
    isTabletOrMobileIpadMax === true &&
    isTabletOrMobileIpad === false
  ) {
    width = "100%";
    TabletOrMobileHeight = "246px";
    legendLabelFont = 8;
    isMobile = true;
  }else if (
    isTabletOrMobile === true &&
    isTabletOrMobileIpadMax === true &&
    isTabletOrMobileIpad === false
  ) {
    width = "100%";
    TabletOrMobileHeight = "246px";
    legendLabelFont = 8;
    isMobile = true;
  }else if(
    isTabletOrMobile === true &&
    isTabletOrMobileIpadMax === false &&
    isTabletOrMobileIpad === false
  ){
    width = "50%";
    TabletOrMobileHeight = "246px";
    legendLabelFont = 8;
    isMobile = true;
  }
  else{
    width = "100%";
    TabletOrMobileHeight = "246px";
    legendLabelFont = 8;
    isMobile = true;
  }
  return (
    <CardContent>
      <ChooseViewDropdown width={width} height={TabletOrMobileHeight}/>
     </CardContent>
  );
}
